import { render, staticRenderFns } from "./AdminBase.vue?vue&type=template&id=c72fd476&scoped=true&"
import script from "./AdminBase.vue?vue&type=script&lang=js&"
export * from "./AdminBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72fd476",
  null
  
)

export default component.exports